import { createPortal } from "react-dom";
import { ReactNode, useState, useEffect } from "react";

interface TeleportProps {
  to: string;
  children: ReactNode;
  // 新增：插入位置（最前面 / 最后面，默认最后）
  position?: "prepend" | "append";
}

export default function Teleport({ to, children, position = "append" }: TeleportProps): JSX.Element | null {
  const [targetElement, setTargetElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const element = document.querySelector(to);
    if (element) {
      setTargetElement(element as HTMLElement);
    } else {
      console.warn(`Target element "${to}" not found`);
    }
  }, [to]);

  if (!targetElement) {
    return null;
  }

  // 创建一个临时容器，portal 会把内容渲染到这里
  const tempContainer = document.createElement("div");
  if (position === "prepend") {
    targetElement.prepend(tempContainer);
  } else {
    targetElement.appendChild(tempContainer);
  }

  return createPortal(children, tempContainer);
}
